// extracted by mini-css-extract-plugin
module.exports = {"summaryPanel":"SummaryPanel_summaryPanel__3QKWp"};